import AnimalNumbersBeef from './AnimalNumbersBeef'
import AnimalNumbersDairySupport from './AnimalNumbersDairySupport'
import AnimalNumbersDeer from './AnimalNumbersDeer'
import AnimalNumbersLifestyleOther from './AnimalNumbersLifestyleOther'
import AnimalNumbersSheep from './AnimalNumbersSheep'
import Beef from './Beef'
import BeefDisease from './BeefDisease'
import BeefParasiteManagement from './BeefParasiteManagement'
import BeefTraceElements from './BeefTraceElements'
import Client from './Client'
import ClientDetails from './ClientDetails'
import ContactDetails from './ContactDetails'
import DairySupport from './DairySupport'
import DeerDisease from './DeerDisease'
import DeerParasites from './DeerParasites'
import DeerReproduction from './DeerReproduction'
import DeerTraceElements from './DeerTraceElements'
import DeerVelveting from './DeerVelveting'
import Disclaimer from './Disclaimer'
import Dogs from './Dogs'
import DrugAllocations from './DrugAllocations'
import EmailNotifications from './EmailNotifications'
import HoggetMating from './HoggetMating'
import LambProduction from './LambProduction'
import SheepGeneral from './SheepGeneral'
import SheepReproductionPlan from './SheepReproductionPlan'

export const generalFarmConsultComponents = {
  AnimalNumbersBeef,
  AnimalNumbersDairySupport,
  AnimalNumbersDeer,
  AnimalNumbersLifestyleOther,
  AnimalNumbersSheep,
  Beef,
  BeefDisease,
  BeefParasiteManagement,
  BeefTraceElements,
  Client,
  ClientDetails,
  ContactDetails,
  DairySupport,
  DeerDisease,
  DeerParasites,
  DeerReproduction,
  DeerTraceElements,
  DeerVelveting,
  Disclaimer,
  Dogs,
  DrugAllocations,
  EmailNotifications,
  HoggetMating,
  LambProduction,
  SheepGeneral,
  SheepReproductionPlan,
}
